import { IS_LOCALHOST } from "@/config/Constants";
import { AESGCM_ENCRYPT } from "@/utils/aes-256-GCM";
import { PF_BASE_URL } from "@/services/ServiceConstants";

export const eventTracker = (() => {
  let initialized = false;
  let events = [];
  let lastActivity = Date.now();

  const initialize = () => {
    if (initialized) return;
    initialized = true;

    setInterval(() => {
      if (events.length >= 5 || Date.now() - lastActivity >= 10000) flush();
    }, 10000);

    window.addEventListener("beforeunload", () => {
      flush();
    });
  };

  const saveEvent = (name) => {
    if (!initialized) return;
    const timeStamp = Date.now();
    const isDuplicate = events.some((event) => event.name === name && event.timeStamp === timeStamp);
    if (isDuplicate) return;
    events.push({ name, timeStamp });
    lastActivity = timeStamp;
    if (name === "v2_sidebar_subUser_switched" || name === "v2_logout") flush();
  };

  const flush = () => {
    if (!events.length) return;
    const postData = {
      trackEvents: 1,
      events: events,
    };

    const res = navigator.sendBeacon(
      PF_BASE_URL,
      JSON.stringify({
        postData: IS_LOCALHOST ? JSON.stringify(postData) : AESGCM_ENCRYPT(JSON.stringify(postData)),
        debug: !!IS_LOCALHOST,
      })
    );
    console.log(`PSS Events flushed. Success: ${res}`);
    if (res) events = [];
  };

  return {
    initialize,
    saveEvent,
  };
})();
